import { render, staticRenderFns } from "./EditMembernew.vue?vue&type=template&id=980912c0&scoped=true"
import script from "./EditMembernew.vue?vue&type=script&lang=js"
export * from "./EditMembernew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980912c0",
  null
  
)

export default component.exports